
// ラジオボタンの状態に応じてフォームを切り替える関数
function toggleForm() {
    var userType = document.querySelector('input[name="user-type"]:checked').value;
    
    // 個人フォームと法人フォームの表示切り替え
    if (userType === 'personal') {
        document.getElementById('personal-form').style.display = 'grid';
        document.getElementById('corporate-form').style.display = 'none';
        //個人フォームを有効化、法人フォームを無効化
        toggleDisabled('personal-form', false);
        toggleDisabled('corporate-form', true);
    } else if (userType === 'corporate') {
        document.getElementById('personal-form').style.display = 'none';
        document.getElementById('corporate-form').style.display = 'grid';
        //法人フォームを有効化、個人フォームを無効化
        toggleDisabled('personal-form', true);
        toggleDisabled('corporate-form', false);
      
    }
}

function toggleDisabled(formId, disabled) {
    var formElements = document.getElementById(formId).querySelectorAll('input, select, textarea');
    formElements.forEach(function(element) {
        element.disabled = disabled;
    });
}


// ページロード時に個人フォームを表示（デフォルト）
window.onload = function() {
    toggleForm();
};

// ラジオボタンにイベントリスナーを追加してフォームを切り替える
var radioButtons = document.querySelectorAll('input[name="user-type"]');
radioButtons.forEach(function(radio) {
    radio.addEventListener('change', toggleForm);
});

